import { buildApiUrl, Type, sendPostRequest } from '@/api/api'

export async function approveTariffs(tariffs: number[]) {
  const query = tariffs.map(id => `tariffIds=${id}`).join('&');
  const url = buildApiUrl(Type.Core, `/tariffs/providers/approve?${query}`)
  await sendPostRequest(url)
}
